import { render, staticRenderFns } from "./quickWithdraBenSuc.vue?vue&type=template&id=4794824d&scoped=true&"
import script from "./quickWithdraBenSuc.vue?vue&type=script&lang=js&"
export * from "./quickWithdraBenSuc.vue?vue&type=script&lang=js&"
import style0 from "./quickWithdraBenSuc.vue?vue&type=style&index=0&id=4794824d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794824d",
  null
  
)

export default component.exports